import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import 'dayjs/locale/th';

dayjs.extend(buddhistEra);
dayjs.locale('th');

const formatThaiDate = (d) => dayjs(d).format('DD MMM BBBB');

export default formatThaiDate;
